import { render } from "./DefinirRegrasCentro.vue?vue&type=template&id=16e5b2e4&scoped=true"
import script from "./DefinirRegrasCentro.vue?vue&type=script&lang=js"
export * from "./DefinirRegrasCentro.vue?vue&type=script&lang=js"

import "./DefinirRegrasCentro.vue?vue&type=style&index=0&id=16e5b2e4&lang=sass"
import "./DefinirRegrasCentro.vue?vue&type=style&index=1&id=16e5b2e4&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e5b2e4"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QTable,QInput,QIcon,QCard,QCardSection,QCheckbox,QSeparator,QTd,QPagination,QSelect});
